// src/store/reservasStore.js

import { create } from 'zustand';
import { collection, getDocs, query, orderBy, doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { toast } from 'react-toastify';

const useReservasStore = create((set, get) => ({
  reservas: [],
  chales: [],
  hospedes: [],
  manutencoes: [],
  configuracoes: null,
  loading: true,

  fetchInitialData: async () => {
    set({ loading: true });
    try {
      const chalesQuery = query(collection(db, 'chales'), orderBy('numero'));
      const reservasQuery = query(collection(db, 'reservas'), orderBy('dataCheckin', 'desc'));
      const hospedesQuery = query(collection(db, 'hospedes'), orderBy('nome'));
      const manutencoesQuery = query(collection(db, 'manutencoes'));
      const configRef = doc(db, 'configuracoes', 'gerais'); // Referência ÚNICA para as configurações

      const [chalesSnapshot, reservasSnapshot, hospedesSnapshot, manutencoesSnapshot, configSnap] = await Promise.all([
        getDocs(chalesQuery),
        getDocs(reservasQuery),
        getDocs(hospedesQuery),
        getDocs(manutencoesQuery),
        getDoc(configRef)
      ]);

      const chalesData = chalesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const reservasData = reservasSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const hospedesData = hospedesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const manutencoesData = manutencoesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      
      // VALORES PADRÃO PARA TODAS AS CONFIGURAÇÕES
      const configuracoesData = configSnap.exists() 
        ? configSnap.data() 
        : { 
            checkin: '14:00', 
            checkout: '12:00',
            diasAntecedenciaCancelamento: 15,
            percentualMultaAntecedencia: 20,
          };

      set({
        chales: chalesData,
        reservas: reservasData,
        hospedes: hospedesData,
        manutencoes: manutencoesData,
        configuracoes: configuracoesData,
        loading: false,
      });
    } catch (error) {
      console.error("Erro ao buscar dados iniciais:", error);
      toast.error("Falha ao carregar os dados do sistema.");
      set({ loading: false });
    }
  },

  liberarChale: async (chaleId) => {
    try {
      const chaleRef = doc(db, 'chales', chaleId);
      await updateDoc(chaleRef, { status: 'Disponível' });
      set((state) => ({
        chales: state.chales.map(chale =>
          chale.id === chaleId ? { ...chale, status: 'Disponível' } : chale
        ),
      }));
      toast.success('Chalé liberado para a próxima reserva!');
    } catch (error) {
      console.error("Erro ao liberar o chalé:", error);
      toast.error("Não foi possível liberar o chalé.");
    }
  },
}));

export default useReservasStore;

